import { useLocalStorage, useMediaQuery } from "@vueuse/core";
import { defineStore } from "pinia";
import { computed } from "vue";

export enum ThemeType {
	SYSTEM_DEFAULT,
	LIGHT,
	DARK,
}

export const useThemeStore = defineStore("theme", () => {
	const theme = useLocalStorage<ThemeType>("theme", ThemeType.SYSTEM_DEFAULT);

	const isPreferredDark = useMediaQuery("(prefers-color-scheme: dark)");

	const isDark = computed(() => {
		if (theme.value === ThemeType.SYSTEM_DEFAULT) {
			return isPreferredDark.value;
		}

		return theme.value === ThemeType.DARK ? true : false;
	});

	return {
		theme,
		isDark,
	};
});
